import type { TaxCalculationResult } from '#calculator/types'
import { TaxKey, type TaxMetadata } from '#dictionary'
import { TAX_BY_KEY } from '#dictionary/taxes'

import type { ITaxCalculator, NoTaxVariety, TaxBracketBreakdown } from './types'

const MEDICARE_TAX_RATE = 0.0145

type MedicareTaxKey = TaxKey.TaxMedicare | TaxKey.TaxMedicareSE

class MedicareTax implements ITaxCalculator<NoTaxVariety> {
  public readonly metadata: TaxMetadata

  constructor(taxKey: MedicareTaxKey) {
    this.metadata = TAX_BY_KEY.get(taxKey)!
  }

  public getTaxRate(_year: number): number {
    return MEDICARE_TAX_RATE
  }

  public getTaxableThreshold(_year: number): number {
    return Infinity
  }

  public calculate(amount: number, year: number): TaxCalculationResult {
    const taxRate = this.getTaxRate(year)
    const totalTax = amount * taxRate

    const bracket: TaxBracketBreakdown = {
      year: year,
      filingStatus: 'N/A',
      from: 0,
      to: amount,
      taxRate: taxRate,
      description: 'Medicare tax on all income',
      incomeInBracket: amount,
      taxInBracket: totalTax,
    }

    return {
      taxMetadata: this.metadata,
      amount,
      taxableIncome: amount,
      standardDeduction: 0,
      effectiveRate: taxRate,
      totalTax,
      bracketBreakdown: [bracket],
    }
  }
}

export default MedicareTax
